import React, { useEffect, useRef, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { apiCall } from "../../../../utils/axiosService";
import { apiResponse } from "../../../../utils/apiResponse";
import Loader from "../../../Loader/Loader";
import { commonService } from "../../../../utils/commonService";
import NoteIcon from "../../../../Assets/Images/CRM/notes.svg";
import downloadIcon from "../../../../Assets/Images/Operation/downloadIcon.svg";
import { API_URL } from "../../../../utils/apiRoutes";
import { compName } from "../../../../utils/constant";
import WidgetDetailModal from "../../WidgetDetailModal";
import infoIcon from "../../../../Assets/Images/Action Icons/infoIcon..svg";
import { useSelector } from "react-redux";
import WidgetNote from "../../WidgetNote";
import AddWidgetModal from "../../AddWidgetModal";
import { useParams } from "react-router-dom";
import emailIcon from "../../../../Assets/Images/Email.svg";
import Comments from "../Comments/Comment";
import moment from "moment";

const BookingPaceTable = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
}) => {
  const tableData = [
    {
      id: 1,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 2,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 3,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 4,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 5,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 6,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 7,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 8,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 9,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
    {
      id: 10,
      propertyCode: "-",
      AsOfDate: "",
      Dates: "",
      TotalRevenueCurrentYear: "0",
      TotalRevenuePreviousYear: "0",
      TotalRMSCurrentYear: 0,
      TotalRMSPreviousYear: 0,
      TotalADRCurrentYear: "0",
      TotalADRPreviousYear: "0",
    },
  ];
  const [bookingPaceData, setBookingPaceData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showNoteSidebar, setShowNoteSidebar] = useState(false);
  const propertyDetailFromRTK = useSelector(
    (store) => store.headerProperty.propertyDetail
  );
  const defaultAsOfDateFromRTK = useSelector(
    (store) => store.headerProperty.defaultAsOfDate
  );
  const bookingPaceMonth = useSelector(
    (store) => store.headerProperty.bookingPaceMonth
  );
  const { snapshottitle, propertyCode, snapshotId } = useParams();
  const closeNoteSideBar = () => {
    setShowNoteSidebar(false);
  };
  const [widgetModal, setWidgetModal] = useState(false);
  const widgetDetailRef = useRef();

  const closeWidgetModal = () => {
    setWidgetModal(false);
  };

  const getBookingPaceDetail = async () => {
    const asOfDateStr = bookingPaceMonth || para?.asOfDate;
    if (!asOfDateStr) return;

    setLoading(true);

    const m = moment(asOfDateStr);
    const startDate = m.startOf("month").format("YYYY-MM-DD");
    const endDate = m.endOf("month").format("YYYY-MM-DD");

    const payload = {
      AsOfDate: para?.asOfDate,
      startDate: startDate,
      endDate: endDate,
      propertyCode: para?.propertyCode || propertyDetailFromRTK?.propertycode,
    };

    const originalPayload = {
      AsOfDate: bookingPaceMonth || para?.asOfDate,
      propertyCode: para?.propertyCode,
    };

    const [paceResRaw, occResRaw, otbResRaw, ratesResRaw] = await Promise.all([
      apiCall(
        {
          method: "POST",
          url: API_URL.BASE_API_URL.SnapShot + API_URL.BOOKING_PACE.CHART,
          body: originalPayload,
        },
        false
      ),
      apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.RATEIQ_YIELD.GET_OCCUPANCY_BY_DATES,
          body: payload,
        },
        false
      ),
      apiCall(
        {
          method: "POST",
          url: API_URL.BASE_API_URL.SnapShot + API_URL.DAILY_SUMMARY.ORG,
          body: payload,
        },
        false
      ),
      apiCall(
        {
          method: "POST",
          url:
            API_URL.BASE_API_URL.SnapShot +
            API_URL.DAILY_SUMMARY.STLY_LY_COMSET_RATES,
          body: payload,
        },
        false
      ),
    ]);

    const paceRes = apiResponse(false, paceResRaw);
    const occRes = apiResponse(false, occResRaw);
    const otbRes = apiResponse(false, otbResRaw);
    const ratesRes = apiResponse(false, ratesResRaw);

    const paceDataApi = paceRes?.isValidate ? paceRes?.data?.data || [] : [];
    const occDataApi = occRes?.isValidate ? occRes?.data?.data || [] : [];
    const otbDataApi = otbRes?.isValidate ? otbRes?.data?.data || [] : [];
    const ratesDataApi = ratesRes?.isValidate ? ratesRes?.data?.data || [] : [];

    const defAsOfDate = moment(para?.asOfDate);
    const datesArray = commonService.getAllDatesInMonth(defAsOfDate.year(), defAsOfDate.month());

    const mergedData = datesArray.map((day, index) => {
      const getMatch = (apiData) =>
        apiData.find((x) => {
          const d = x?.Dates || x?.Date || x?.dates || x?.startdate;
          return (
            d && commonService.convertDateInTimezone(d).getDate() === day
          );
        }) || {};

      const paceMatch = getMatch(paceDataApi);
      const occMatch = getMatch(occDataApi);
      const otbMatch = getMatch(otbDataApi);
      const ratesMatch = getMatch(ratesDataApi);

      const dateStr = moment(asOfDateStr).date(day).format("YYYY-MM-DD");

      return {
        id: index + 1,
        Dates: paceMatch.Dates || dateStr,
        TotalRevenueCurrentYear: paceMatch.TotalRevenueCurrentYear || 0,
        TotalRevenuePreviousYear: paceMatch.TotalRevenuePreviousYear || 0,
        RevenueCurrentYear: otbMatch.REV || 0,
        RevenuePreviousYear: ratesMatch.lyrevenue || ratesMatch.ly_revenue || 0,

        TotalRMSCurrentYear: paceMatch.TotalRMSCurrentYear || 0,
        TotalRMSPreviousYear: paceMatch.TotalRMSPreviousYear || 0,
        RMSCurrentYear: occMatch.RMS || 0,
        RMSPreviousYear: occMatch.LY_RMS || 0,

        TotalADRCurrentYear: paceMatch.TotalADRCurrentYear || 0,
        TotalADRPreviousYear: paceMatch.TotalADRPreviousYear || 0,
        ADRCurrentYear: otbMatch.ADR || 0,
        ADRPreviousYear: ratesMatch.lyadr || ratesMatch.ly_adr || 0,

        OccPerCurrentYear: paceMatch.OccPerCurrentYear || 0,
        OccPerPreviousYear: paceMatch.OccPerPreviousYear || 0,
        OccCurrentYear: occMatch.OCC || 0,
        OccPreviousYear: occMatch.LY_OCC || 0,
      };
    });

    if (paceRes?.isValidate || occRes?.isValidate || otbRes?.isValidate || ratesRes?.isValidate) {
      setBookingPaceData(mergedData);
    } else {
      setBookingPaceData(tableData);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (api === 0) {
      setBookingPaceData(tableData);
    } else {
      if (para?.asOfDate) {
        getBookingPaceDetail();
      }
    }
  }, [para?.asOfDate, bookingPaceMonth]);

  const [tblids, settblids] = useState({
    tblBookingPace: commonService.GenerateGUID(),
  });

  return (
    <div className="widget-container" style={{position: "relative"}}>
      {api !== 0 && (
        <div className="gap-1 widget-container-menu">
          {/* <Button className="heading-menu-btns" type="button">
            <img
              src={NoteIcon}
              alt="menuIcon"
              onClick={() => {
                setShowNoteSidebar(true);
              }}
            />
          </Button> */}
          <Button className="heading-menu-btns" type="button" title="Send Mail">
            <img id={commonService.generateGlobalClickTrackerID("BookingPaceTable", "emailicon", propertyCode)}
              src={emailIcon}
              alt="emailIcon"
              onClick={() => {
                commonService.fnSendWidgetMail(
                  tblids.tblBookingPace,
                  "Booking Pace",
                  snapshotId,
                  defaultAsOfDateFromRTK,
                  "",
                  para?.widgetId
                );
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BookingPaceTable", "info", propertyCode)}
              src={infoIcon}
              alt="info"
              onClick={() => {
                widgetDetailRef.current = {
                  widgetdetails: "",
                  usernote: "",
                  compName: compName?.bookingPaceTable,
                  widgetId: para?.widgetId,
                };
                setWidgetModal(true);
              }}
            />
          </Button>
          <Button className="heading-menu-btns" type="button">
            <img id={commonService.generateGlobalClickTrackerID("BookingPaceTable", "menuicon", propertyCode)}
              src={downloadIcon}
              alt="menuIcon"
              import={tblids.tblBookingPace}
              onClick={() =>
                commonService.fnExportInCSV(
                  tblids.tblBookingPace,
                  // "Booking Pace"
                  `${para?.propertyCode}-Booking Pace-${moment(
                    new Date()
                  ).format("MMDDYYYY")}`
                )
              }
            />
          </Button>
        </div>
      )}
      <div className="ViewPropertySetupTable">
        <div className="stripped__table">
          <Table id={tblids.tblBookingPace} responsive>
            <thead>
              <tr>
                <th>Date</th>
                <th className=" text-end border-right">CY Total Rev</th>
                <th className=" text-end">PY Total Rev</th>
                <th className=" text-end">CY Daily Rev</th>
                <th className=" text-end">PY Daily Rev</th>

                <th className=" text-center border-right">CY Total RMS</th>
                <th className=" text-center">PY Total RMS</th>
                <th className=" text-center">CY Daily RMS</th>
                <th className=" text-center">PY Daily RMS</th>

                <th className=" text-end border-right">CY Total ADR</th>
                <th className=" text-end">PY Total ADR</th>
                <th className=" text-end">CY Daily ADR</th>
                <th className=" text-end">PY Daily ADR</th>

                <th className=" text-center border-right">CY Total Occ %</th>
                <th className=" text-center">PY Total Occ %</th>
                <th className=" text-center">CY Daily Occ %</th>
                <th className=" text-center">PY Daily Occ %</th>

              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr style={{ height: "80px", position: "relative" }}>
                  <Loader />
                </tr>
              ) : (
                bookingPaceData?.map((item, index) => (
                  <tr key={item?.id} className="shadowOnHover">
                    <td>
                      {item?.Dates
                        ? commonService?.getDateInFormat(item?.Dates)
                        : ""}
                    </td>
                    <td className="text-end border-right">
                      {item?.TotalRevenueCurrentYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.TotalRevenueCurrentYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>
                    <td className="text-end">
                      {item?.TotalRevenuePreviousYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.TotalRevenuePreviousYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>
                    <td className="text-end">
                      {item?.RevenueCurrentYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.RevenueCurrentYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>
                    <td className="text-end">
                      {item?.RevenuePreviousYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.RevenuePreviousYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>

                    <td className="text-center border-right">
                      {item?.TotalRMSCurrentYear
                        ? commonService.formateRoom(item?.TotalRMSCurrentYear)
                        : 0}
                    </td>
                    <td className="text-center">
                      {item?.TotalRMSPreviousYear
                        ? commonService.formateRoom(item?.TotalRMSPreviousYear)
                        : 0}
                    </td>
                    <td className="text-center">
                      {item?.RMSCurrentYear
                        ? commonService.formateRoom(item?.RMSCurrentYear)
                        : 0}
                    </td>
                    <td className="text-center">
                      {item?.RMSPreviousYear
                        ? commonService.formateRoom(item?.RMSPreviousYear)
                        : 0}
                    </td>

                    <td className="text-end border-right">
                      {item?.TotalADRCurrentYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.TotalADRCurrentYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>
                    <td className="text-end">
                      {item?.TotalADRPreviousYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.TotalADRPreviousYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>
                    <td className="text-end">
                      {item?.ADRCurrentYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.ADRCurrentYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>
                    <td className="text-end">
                      {item?.ADRPreviousYear
                        ? `${commonService.formateAmount(
                            Math.round(item?.ADRPreviousYear)
                          )}`
                        : `${commonService.formateAmount(0)}`}
                    </td>

                    <td className="text-center border-right">
                      {item?.OccPerCurrentYear
                        ? `${Math.round(item?.OccPerCurrentYear)}%`
                        : "0%"}
                    </td>
                    <td className="text-center">
                      {item?.OccPerPreviousYear
                        ? `${Math.round(item?.OccPerPreviousYear)}%`
                        : "0%"}
                    </td>
                    <td className="text-center">
                      {item?.OccCurrentYear
                        ? `${Math.round(item?.OccCurrentYear)}%`
                        : "0%"}
                    </td>
                    <td className="text-center">
                      {item?.OccPreviousYear
                        ? `${Math.round(item?.OccPreviousYear)}%`
                        : "0%"}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </div>
      {api !== 0 && (
        <Comments widgetDetails={para} editorId={"BookingPaceTable"} />
      )}

      {/* {showNoteSidebar && (
                <WidgetNote
                    show={showNoteSidebar}
                    handleClose={closeNoteSideBar}
                    widgetId={para?.widgetId}
                    propertyId={propertyDetailFromRTK?.propertyid}
                    rowTitle={para?.rowTitle}
                />
            )} */}
      {showNoteSidebar && (
        <AddWidgetModal
          showModal={showNoteSidebar}
          closeModal={closeNoteSideBar}
          widgetId={para?.widgetId}
          propertyId={propertyDetailFromRTK?.propertyid}
          rowTitle={para?.rowTitle}
        />
      )}
      {widgetModal && (
        <WidgetDetailModal
          showModal={widgetModal}
          closeModal={closeWidgetModal}
          data={widgetDetailRef.current}
        />
      )}
    </div>
  );
};

export default BookingPaceTable;
